<template>
  <div>
    <div class="uk-section uk-section-small">
      <div class="uk-grid-small" uk-grid>
        <div class="uk-width-1-1">
          <div class="uk-grid-small uk-child-width-1-1@s uk-child-width-1-2@m uk-child-width-1-2@l" uk-grid>
            <div>
              <h3>Items</h3>
            </div>
            <div class="uk-text-right">
              <div class="uk-grid-small uk-flex uk-flex-right uk-flex-middle title-tools" uk-grid>
                <div class="uk-text-small uk-width-expand">
                  Total: {{ resultCount }} / Page: {{ limit }}
                </div>
                <div class="uk-width-1-5">
                  <select name="order_by" class="uk-select" v-model="orderBy" id="order_by" @change="items">
                    <option value="desc">Newest</option>
                    <option value="asc">Oldest</option>
                  </select>
                </div>
                <div class="uk-width-1-5">
                  <router-link :to="{ name: 'NewItem' }" class="uk-button uk-button-default">
                    <i class="fas fa-plus"></i>
                    New
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-width-1-1">
          <Ctable :heads="heads"
                  :data="results"
                  :data-objects="dataObjects"
                  :data-icons="dataIcons"
                  :link-base="'item'"
                  :links="{show: true, delete: true}"
                  :name="'items'"/>
        </div>
        <div class="uk-width-1-1">
          <Pagination :links="paginationLinks"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Ctable from '@/components/ctable'
  import Pagination from '@/components/pagination'
  import qs from 'query-string'

  export default {
    name: "Item",
    components: {Ctable, Pagination},
    data() {
      return {
        results: [],
        heads: ['#ID', 'Product', 'UPC', 'SKU', 'Price', 'Created at'],
        dataObjects: ['id', 'product_name', 'upc', 'sku', 'price', 'created_at'],
        dataIcons: {'price': '<i class="fas fa-lira-sign"></i>' },
        limit: 40,
        offset: 0,
        orderBy: 'desc',
        resultCount: 0,
        paginationLinks: []
      }
    },
    activated() {
      this.getItems()
    },
    mounted() {
      this.getItems()
    },
    watch: {
      '$route'() {
        window.scrollTo(0,0);
        this.getItems()
      }
    },
    methods: {
      async items() {
        const params = {limit: this.limit, offset: this.offset, order_by: this.orderBy};

        this.$router.push({name: 'Item', query: params});
      },
      async getItems() {
        const self = this;

        self.paginationLinks = [];

        self.limit = (typeof self.$route.query.limit !== 'undefined') ? self.$route.query.limit : 40;
        self.offset = (typeof self.$route.query.offset !== 'undefined') ? self.$route.query.offset : 0;
        self.orderBy = (typeof self.$route.query.order_by !== 'undefined') ? self.$route.query.order_by : 'desc';

        self.$request().get(`/item`, {limit: self.limit, offset: self.offset, order_by: self.orderBy})
          .then(r => {
            r = self.$request().successHandler(r).data;

            self.resultCount = r.total_count;

            const pages = Math.ceil((self.resultCount / self.limit));

            for(let i = 1; i <= pages; i++) {
              const link = qs.stringify({limit: self.limit, offset: (self.limit * i - 40), order_by: self.orderBy});
              self.paginationLinks.push({page: i, link: `?` + link});
            }

            if (r.items.length > 0) {
              self.results = r.items;
            }
          });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Item.vue